// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__FK5Yn","InputElement":"Input_InputElement__DB-rT"};